import React, { useState, useEffect } from 'react'
import AuthLayout from '../../layout/AuthLayout'
import OtpTimer from 'otp-timer';
import { useFormik } from 'formik';
import { Link, useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from "react-redux";
import { verifyOtp, resendOtp } from "../../redux/auth/actions";
import * as Yup from "yup";
import { Dialog, DialogContent, DialogContentText } from "@material-ui/core";
import { Toast } from "../../components";
import axios from "../../redux/axios";
import { api } from "../../utils/constants";
import { login } from "../../redux/auth/actions";
import { getFirebaseAnalyticsInstance } from '../../firebase';
import ReactGA from 'react-ga';

const initialValues = {
  receivedCode: "",
};

export default function ConfirmVerification() {
  const [success, setSuccess] = useState(false);
  const [resentOtp, setResentOtp] = useState(false);
  const [invalidOtp, setInvalidOtp] = useState(false);
  const user = useSelector((state) => state.auth);
  const [open, setOpen] = useState(false);
  let history = useHistory();
  const dispatch = useDispatch();

  const LoginData = JSON.parse(localStorage.getItem("LoginData"));

  const verfiySchema = Yup.object().shape({
    receivedCode: Yup.string()
      .required()
      .matches(/^[0-9]+$/, "Must be only digits")
      .min(6, "Must be exactly 6 digits"),
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };


  const handleResend = async () => {
    const email = user.email;
    const mobile = user.mobile;
    const val = { mobile, email };
    await axios.post(api.resetpassword, val).then(
      (response) => {
        setResentOtp(true);
      },
      (error) => {
        // setRes(true)
      }
    );
  };

  useEffect(() => {
    try {
      if (user.verified === true) {
        const username = LoginData.mobile;
        const password = LoginData.password;
        const val = { username, password };
        dispatch(login(val, (res) => {
          setSuccess(true);
          addFireBaseAnalyticsLogin()
          setTimeout(() => {
            history.push("/");
          }, 3000);
        }))
      }
    } catch (error) {
      history.push("/");
    }

  }, [user.verified])

  const addFireBaseAnalytics = async () => {
    try {
      await getFirebaseAnalyticsInstance().logEvent("USER_REGISTER", {
        eventType: "REGISTER",
        platform: "web",
      });
    } catch (error) {
      console.log(error);
    }
    ReactGA.event({
      category: 'REGISTER',
      action: 'REGISTER',
      label: 'REGISTER',
    })
  };
  const addFireBaseAnalyticsLogin = async () => {
    try {
      await getFirebaseAnalyticsInstance().logEvent("USER_LOGIN", {
        eventType: "LOGIN",
        platform: "web",
      });
    } catch (error) {
      console.log(error);
    }
    ReactGA.event({
      category: 'LOGIN',
      action: 'LOGIN',
      label: 'LOGIN',
    })
  };

  const { handleSubmit, handleChange, values, errors } = useFormik({
    initialValues,
    validationSchema: verfiySchema,
    onSubmit: (values) => {
      const otp = values.receivedCode.toString();
      const mobile = user.mobile;
      const val = { mobile, otp };
      dispatch(
        verifyOtp(val, (res) => {
          if (res === "error") {
            setInvalidOtp(true);
          } 
          else {
            // history.push("/");
            addFireBaseAnalytics()
            history.push("/");
            localStorage.setItem("CTKN", user.token);
          }
        })
      );
     
    },
  });
  return (
    <AuthLayout>
      <div className="confirmVerification">
        <Toast
          text={"Sign-Up Success, Please wait till we redirect"}
          type="success"
          open={success}
          setClose={() => {
            setSuccess(false);
          }}
        />   
        <Toast
          text={"Otp Sent successfully"}
          type="success"
          open={resentOtp}
          setClose={() => {
            setResentOtp(false);
          }}
        />
        <Toast
          text={"Invalid Otp"}
          type="error"
          open={invalidOtp}
          setClose={() => {
            setInvalidOtp(false);
          }}
        />

        <div className="heads">
          <label className='h2head'>Confirm Verification Code</label>
          <p>Enter the code you just received in your mail</p>
        </div>
        <form onSubmit={handleSubmit}>
          <label htmlFor="Verification Code">Verification Code</label>
          <div>
            <input
              className="inputForm"
              type="number"
              name="receivedCode"
              value={values.receivedCode}
              onChange={handleChange}
            />
            {errors.receivedCode ? (
              <div className="error">{errors.receivedCode}</div>
            ) : null}
          </div>
          <button type="submit" className="sumbitBtn">
            Confirm Code
          </button>
        </form>
        <div className="resendCode">
          <p>
            If you didn’t get the code after three minutes, click {" "}
            <OtpTimer textColor="red" seconds={30} minutes={3} background={"none"} buttonColor={'#4D777C'} resend={handleResend} />
          </p>

        </div>
      </div>

      <Dialog open={open} onClose={handleClose}>
        <DialogContent>
          <DialogContentText>
            <div className="dialoglimit">
              <img crossOrigin="anonymous"
                src={require("../../assets/images/error.png").default}
                alt=""
              />
              <p>
                You have exceeded your code entry limit. To assist you, kindly
                reach out to us via
              </p>{" "}
              <div className="support">
                support@doctall.com <br />
                or call 09010996000
              </div>
              <img crossOrigin="anonymous"
                className="xbutton"
                onClick={handleClose}
                src={require("../../assets/images/Xbutton.svg").default}
                alt=""
              />
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </AuthLayout>
  );
}
